import React from "react";
import { TrendingUp, TrendingDown } from "lucide-react";

/**
 * UpDownChevron - Shows an up or down trend arrow
 * @param {object} props
 * @param {number} props.value - Positive shows up, negative shows down
 * @param {boolean} [props.dark] - Use vivid colors (limegreen/orangered) vs standard (green/red)
 * @returns {JSX.Element}
 * @author Forge
 * @version 2.0.0
 * @since 2025-04-11
 */
export default function UpDownChevron({ value = 0, dark = false }) {
  if (value > 0) return <TrendingUp size={16} className={dark ? "text-emerald-400" : "text-green-600"} />;
  if (value === 0) return null;
  return <TrendingDown size={16} className={dark ? "text-rose-400" : "text-red-600"} />;
}
